import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class PressRelease extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const pressRelease = this.props.pressRelease;

        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background press-release-page">
                    <Banner heading="Press Release" />
                    <BackButton href={hyperlinks["pressReleases"]} text="❮ Press releases" />
                    <Row className="content">
                        <Col md={12}>
                            <div key={pressRelease.id} className="press-release">
                                <Row>
                                    <Col lg={4} className="banner">
                                        <img src={pressRelease.bannerUrl} className="img-responsive" />
                                    </Col>
                                    <Col lg={8} className="content-and-learn-more">
                                        <h1>{pressRelease.title}</h1>
                                        <p>{pressRelease.formattedDate}</p>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row className="content">
                        <Col md={12}>
                            <div className="press-release-body" dangerouslySetInnerHTML={{ __html: pressRelease.body }} />
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/PressRelease.jsx.erb